import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { userSelector } from "../features/user/userSlice";

function PublicLayout({ children }) {
  const { user } = useSelector(userSelector);

  if (user) return <Navigate to="/" />;
  return children;
}

export default PublicLayout;
